module.exports = __webpack_public_path__ + "static/media/dashboard_menu_fr.d2fc946a.png";